import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../axiosConfig";
import { ReportsResponse } from "../../types/ReportTypes";

export default function useGetReports(page: number, hideEmpty = false) {
  return useQuery({
    queryKey: ["reports", page, hideEmpty],
    queryFn: async () => {
      return axiosInstance
        .get(`/reports?page=${page}${hideEmpty ? "&hideEmpty=1" : ""}`)
        .then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: ReportsResponse) => data,
    retry: false,
  });
}
